import { Spinner } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import useAxios from 'axios-hooks';
import React, { useState } from 'react';
import DeleteCobrandDashboardTaskModal from '../Components/DeleteCobrandDashboardTaskModal';
import DefaultTable from '../Components/DefaultTable';
import { useHistory, useRouteMatch } from 'react-router-dom';

const DashboardTasksDefaultPage = () => {
    const history = useHistory();

    const [{ data: cobrandDashboardTasks, loading }, refetch] = useAxios('internal/dashboard-tasks/cobrand-exclusions');
    const [showDeleteModal, { toggle: toggleDeleteModal }] = useBoolean(false);
    const [selectedCobrandDashboardTask, setSelectedCobrandDashboardTask] = useState(null);

    if (loading || !cobrandDashboardTasks) {
        return <Spinner className="absolute-center" label="Loading Cobrand Dashboard Tasks..." />;
    }

    return (
        <>
            <DefaultTable
                cobrandDashboardTasks={cobrandDashboardTasks}
                editOnClick={(id) => history.push(`/cobrand-settings-feature/dashboard-tasks/${id}/wizard`)}
                deleteOnClick={toggleDeleteModal}
                createOnClick={() => history.push(`/cobrand-settings-feature/dashboard-tasks/wizard`)}
                setSelectedCobrandDashboardTask={setSelectedCobrandDashboardTask}
            />
            <DeleteCobrandDashboardTaskModal
                showModal={showDeleteModal}
                toggleShowModal={toggleDeleteModal}
                cobrandDashboardTask={selectedCobrandDashboardTask}
                onDelete={refetch}
            />
        </>
    );
};

export default DashboardTasksDefaultPage;
